import { useState } from 'react';
import { Button } from '@platform/components';
import { CreateIntroductionModal } from '../introductions/CreateIntroductionModal';
import { CreateDemoCohortModal } from './CreateDemoCohortModal';
import { CreateDemoCommunityAnnouncementModal } from './CreateDemoCommunityAnnouncementModal';
import { CreateDemoCommunityWinModal } from './CreateDemoCommunityWinModal';
import { CreateDemoEventModal } from './CreateDemoEventModal';
import { CreateDemoFundingOpportunityModal } from './CreateDemoFundingOpportunityModal';
import { CreateDemoJobPostingModal } from './CreateDemoJobPostingModal';
import { CreateDemoMatchModal } from './CreateDemoMatchModal';
import { CreateDemoOrganizationModal } from './CreateDemoOrganizationModal';
import { CreateDemoProjectModal } from './CreateDemoProjectModal';
import { CreateDemoUserModal } from './CreateDemoUserModal';

type DemoDataModal =
  | 'organization'
  | 'user'
  | 'project'
  | 'match'
  | 'introduction'
  | 'cohort'
  | 'event'
  | 'communityWin'
  | 'communityAnnouncement'
  | 'jobPosting'
  | 'fundingOpportunity'
  | null;

export const DemoDataAdmin = () => {
  const [openModal, setOpenModal] = useState<DemoDataModal>(null);

  return (
    <div className='flex flex-col gap-4 items-center p-4'>
      <h1 className='text-2xl font-semibold'>Demo Data</h1>
      <p className='max-w-xl text-center text-sm text-gray-600'>
        Quickly create fresh demo users, organizations, projects, and matches for building client
        demo scenarios, instead of reusing real records that already have match history attached.
        Created records use the test+&lt;id&gt;@movingworlds.org email convention and a
        &quot;DEMO —&quot; name prefix, so they&apos;re recognizable in other admin views.
      </p>
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-md'>
        <Button variant='secondary-color' onPress={() => setOpenModal('cohort')}>
          Create cohort
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('organization')}>
          Create organization (+ rep)
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('user')}>
          Create user
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('project')}>
          Create project
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('match')}>
          Create match
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('introduction')}>
          Create introduction
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('event')}>
          Create event
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('communityWin')}>
          Create community win
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('communityAnnouncement')}>
          Create community announcement
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('jobPosting')}>
          Create job posting
        </Button>
        <Button variant='secondary-color' onPress={() => setOpenModal('fundingOpportunity')}>
          Create funding opportunity
        </Button>
      </div>
      {openModal === 'cohort' && <CreateDemoCohortModal onClose={() => setOpenModal(null)} />}
      {openModal === 'organization' && (
        <CreateDemoOrganizationModal onClose={() => setOpenModal(null)} />
      )}
      {openModal === 'user' && <CreateDemoUserModal onClose={() => setOpenModal(null)} />}
      {openModal === 'project' && <CreateDemoProjectModal onClose={() => setOpenModal(null)} />}
      {openModal === 'match' && <CreateDemoMatchModal onClose={() => setOpenModal(null)} />}
      {openModal === 'introduction' && (
        <CreateIntroductionModal onClose={() => setOpenModal(null)} />
      )}
      {openModal === 'event' && <CreateDemoEventModal onClose={() => setOpenModal(null)} />}
      {openModal === 'communityWin' && (
        <CreateDemoCommunityWinModal onClose={() => setOpenModal(null)} />
      )}
      {openModal === 'communityAnnouncement' && (
        <CreateDemoCommunityAnnouncementModal onClose={() => setOpenModal(null)} />
      )}
      {openModal === 'jobPosting' && (
        <CreateDemoJobPostingModal onClose={() => setOpenModal(null)} />
      )}
      {openModal === 'fundingOpportunity' && (
        <CreateDemoFundingOpportunityModal onClose={() => setOpenModal(null)} />
      )}
    </div>
  );
};
